module.exports = __webpack_public_path__ + "static/img/product_01.1da6e48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/product_01.png
// module id = 7N7l
// module chunks = 34